import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=5c7f3361&scoped=true"
import script from "./Captcha.vue?vue&type=script&lang=js"
export * from "./Captcha.vue?vue&type=script&lang=js"
import style0 from "./Captcha.vue?vue&type=style&index=0&id=5c7f3361&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7f3361",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c7f3361')) {
      api.createRecord('5c7f3361', component.options)
    } else {
      api.reload('5c7f3361', component.options)
    }
    module.hot.accept("./Captcha.vue?vue&type=template&id=5c7f3361&scoped=true", function () {
      api.rerender('5c7f3361', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/components/Captcha.vue"
export default component.exports